import { Show } from 'solid-js'
import Card from '~/components/Card'
import Icon from '~/components/Icon'
import CustomerStatesEditor from '~/layers/CustomerStatesEditor'
import type { CustomerStateConfigType } from '~/types/Settings'
import type { TabCrmProps } from './types'

/** Pestaña CRM: las etapas del ciclo de vida que alimentan el tablero del cliente. */
function TabCrm(props: TabCrmProps) {
  const { form } = props

  return (
    <Card>
      <Card.Title>
        <div class="flex items-center">
          <Icon icon="material-symbols-light:view-kanban-outline" size={20} class="mr-2" />
          <h2 class="text-xl font-semibold">Estados del cliente</h2>
        </div>
      </Card.Title>
      <Card.Body>
        <p class="text-sm text-foreground-subtle mb-4">Son las columnas del tablero del CRM: nombre, color y orden de cada etapa.</p>
        <CustomerStatesEditor value={(form.values().customerStatesJson as CustomerStateConfigType[]) ?? []} onChange={stages => form.setValue('customerStatesJson', stages)} />
        <Show when={form.error('customerStatesJson')}>
          <p class="mt-2 text-sm text-danger">{form.error('customerStatesJson')}</p>
        </Show>
      </Card.Body>
    </Card>
  )
}

export default TabCrm
